import { useState } from 'react';
import CustomButton from 'components/CustomInput/Button';
import { getTimeWithTimeZone } from 'utility/general';
import { roleDisplayLookup } from 'utility/lookup';

const useCommentHistoryData = () => {
    const [isShow, setIsShow] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [rows, setRows] = useState([]);

    const handleView = (row) => {
        setIsShow(true);
        setSelectedRow(row);
    };

    const rawColumn = [
        {
            field: 'createdDtm',
            headerName: 'Date',
            width: 150,
            valueGetter: (params) => {
                return getTimeWithTimeZone(params.value).format('YYYY-MM-DD HH:mm:ss');
            },
        },
        {
            field: 'from',
            headerName: 'From',
            width: 150,
            valueGetter: (param) => {
                const display = roleDisplayLookup[param.value];

                if (!display) {
                    return param.value;
                }

                return display;
            },
        },
        {
            field: 'to',
            headerName: 'To',
            width: 150,
            valueGetter: (param) => {
                const display = roleDisplayLookup[param.value];

                if (!display) {
                    return param.value;
                }

                return display;
            },
        },
        { field: 'comment', headerName: 'Comment', width: 400 },
        {
            field: 'files',
            headerName: 'Attachment',
            width: 150,
            valueGetter: (params) => {
                if (params.row.files?.length > 0) {
                    return <CustomButton onClick={() => handleView(params.row)}>View</CustomButton>;
                } else {
                    return '-';
                }
            },
        },
    ];

    return {
        columns: rawColumn,
        rows: rows,
        isShow,
        setIsShow,
        setSelectedRow,
        selectedRow,
        setRows,
    };
};

export default useCommentHistoryData;
